import { useColumn } from "../useColumn";

export const useColType = () => {
  return useColumn("filetype", { title: "Type" });
};
